"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'admin': {
    width: 512,
    height: 512,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8.5 21a.48.48 0 01-.107-.012C8.309 20.97 0 19.047 0 9.929V3.5a.5.5 0 01.324-.468l8-3a.507.507 0 01.352 0l8 3A.5.5 0 0117 3.5v6.429c0 9.118-8.309 11.042-8.393 11.06A.547.547 0 018.5 21zM20 19c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM23.25 24h-6.5a.75.75 0 01-.75-.75v-.5A2.752 2.752 0 0118.75 20h2.5A2.752 2.752 0 0124 22.75v.5a.75.75 0 01-.75.75z"/>'
  }
});